module.exports = __webpack_public_path__ + "img/logo.de4ad2f0.png";